module.exports = __webpack_public_path__ + "static/media/3.5f7e7ecd.jpg";